import * as o from "react";
import s from "../lib/IconBase.es.js";
import t from "../defs/Flask.es.js";
const a = o.forwardRef((e, r) => /* @__PURE__ */ o.createElement(s, { ref: r, ...e, weights: t }));
a.displayName = "FlaskIcon";
const n = a;
export {
  n as Flask,
  a as FlaskIcon
};
